var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "donation-starter",
      attrs: {
        "aria-label": _vm.isFrenchLanguage
          ? "Assistant de don"
          : "Donation helper",
        role: "dialog",
      },
    },
    [
      _c("div", { staticClass: "donation-starter__container" }, [
        _c(
          "div",
          {
            staticClass: "donation-starter__group",
            attrs: { id: "DonationType" },
          },
          [
            _c("div", { staticClass: "donation-starter__type-container" }, [
              _c(
                "button",
                {
                  staticClass:
                    "donation-starter__type-button donation-starter__type-button--single",
                  class: { "is-active": _vm.issingledonation == true },
                  attrs: {
                    "aria-label":
                      (_vm.isFrenchLanguage ? "Sélectionner " : "Select ") +
                      _vm.singleButtonCta,
                    role: "button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setDonationSingle()
                    },
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.singleButtonCta))])]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "donation-starter__type-container" }, [
              _c(
                "button",
                {
                  staticClass:
                    "donation-starter__type-button donation-starter__type-button--monthly",
                  class: {
                    "is-active":
                      _vm.issingledonation == false ||
                      _vm.issingledonation == undefined,
                  },
                  attrs: {
                    "aria-label":
                      (_vm.isFrenchLanguage ? "Sélectionner " : "Select ") +
                      _vm.monthlyButtonCta,
                    role: "button",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.setDonationMonthly()
                    },
                  },
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.monthlyButtonCta))]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 30 30",
                      },
                    },
                    [
                      _c("path", {
                        staticClass: "donation-inside",
                        attrs: {
                          d: "M26.3 5.2c-2.7-2.9-7.1-2.9-9.9-.3l-.3.3L15 6.3l-1.1-1.2C12.6 3.8 10.7 3 8.8 3S5 3.8 3.7 5.2C.9 8.1.9 12.8 3.7 15.7l10.4 11c.2.3.5.4.8.4s.6-.1.8-.4l.1-.1 10.4-11c2.9-2.8 2.9-7.5.1-10.4z",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M27.7 4c-3-3.2-8-3.3-11.1-.3l-.3.3L15 5.3 13.8 4c-1.5-1.6-3.6-2.4-5.7-2.4-2.2-.1-4.3.8-5.8 2.4-3.1 3.3-3.1 8.5 0 11.8L14 28.1c.2.3.6.4.9.4s.7-.1.9-.4l.1-.1 11.7-12.3c3.2-3.2 3.2-8.4.1-11.7zm-1.9 10L15 25.2 4.2 14a5.92 5.92 0 0 1 0-8.2c.9-1 2.2-1.6 3.6-1.7H8c1.5 0 2.8.6 3.8 1.7L14 8.1c.2.3.6.4.9.4s.7-.1.9-.4l.1-.1 2.2-2.3c1.9-2.1 5.2-2.3 7.3-.3l.3.3c2.2 2.4 2.2 6 .1 8.3z",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "donation-starter__group",
            attrs: { id: "AmountButtons" },
          },
          [
            _vm.issingledonation == true
              ? _c(
                  "div",
                  { staticClass: "donation-starter__values-wrapper" },
                  [
                    _vm._l(_vm.values, function (value) {
                      return _c(
                        "div",
                        {
                          key: value.id,
                          staticClass: "donation-starter__value-container",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "donation-starter__button",
                              class: {
                                "is-active":
                                  _vm.activeValueSingle === value.labelAmount &&
                                  _vm.customValue.singleAmount === "",
                              },
                              attrs: {
                                "aria-label": _vm.isFrenchLanguage
                                  ? "Sélectionner " + value.labelAmount + " $"
                                  : "Select $" + value.labelAmount + " amount",
                                role: "button",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.activeValueSingle = value.labelAmount
                                  _vm.customValue.singleAmount = ""
                                  _vm.errors = []
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.isFrenchLanguage
                                      ? value.labelAmount + " $"
                                      : "$" + value.labelAmount
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "donation-starter__value-container",
                        attrs: { id: "CustomAmountButtons" },
                      },
                      [
                        _c("fieldset", { staticClass: "form__group" }, [
                          _c(
                            "div",
                            {
                              key: _vm.customValue.idSingle,
                              staticClass: "field field--with-floating-label",
                              class: {
                                "has-value":
                                  _vm.customValue.singleAmount !== "",
                                "is-active":
                                  _vm.activeValueSingle ===
                                  _vm.customValue.singleAmount,
                                "french-donation": _vm.isFrenchLanguage,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.activeValueSingle =
                                    _vm.customValue.singleAmount
                                  _vm.errors = []
                                },
                              },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "field__label",
                                  attrs: {
                                    "aria-label": _vm.otheramounttext,
                                    for: _vm.customValue.idSingle,
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.otheramounttext)),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._m(0),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.customValue.singleAmount,
                                    expression: "customValue.singleAmount",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "field__input",
                                attrs: {
                                  id: _vm.customValue.idSingle,
                                  autocomplete: "off",
                                  inputmode: "decimal",
                                  maxlength: "8",
                                  pattern: "\\d+(\\.\\d*)?",
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.customValue.singleAmount,
                                },
                                on: {
                                  keyup: function ($event) {
                                    _vm.activeValueSingle =
                                      _vm.customValue.singleAmount
                                  },
                                  keypress: _vm.preventNonNumeric,
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.customValue,
                                      "singleAmount",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ],
                  2
                )
              : _c(
                  "div",
                  {
                    staticClass: "donation-starter__values-wrapper",
                    attrs: { id: "AmountButtonsMo" },
                  },
                  [
                    _vm._l(_vm.values, function (value) {
                      return _c(
                        "div",
                        {
                          key: value.id,
                          staticClass: "donation-starter__value-container",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "donation-starter__button",
                              class: {
                                "is-active":
                                  _vm.activeValueMonthly ===
                                    value.labelAmountMo &&
                                  _vm.customValue.monthlyAmount === "",
                              },
                              attrs: {
                                "aria-label": _vm.isFrenchLanguage
                                  ? "Sélectionner " +
                                    value.labelAmountMo +
                                    " $ par mois"
                                  : "Select $" +
                                    value.labelAmountMo +
                                    " per month",
                                role: "button",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.activeValueMonthly = value.labelAmountMo
                                  _vm.customValue.monthlyAmount = ""
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.isFrenchLanguage
                                      ? value.labelAmountMo + " $"
                                      : "$" + value.labelAmountMo
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "donation-starter__value-container",
                        attrs: { id: "CustomAmountButtons" },
                      },
                      [
                        _c("fieldset", { staticClass: "form__group" }, [
                          _c(
                            "div",
                            {
                              key: _vm.customValue.idMonthly,
                              staticClass:
                                "field field--with-floating-label monthly-donation",
                              class: {
                                "has-value":
                                  _vm.customValue.monthlyAmount !== "",
                                "is-active":
                                  _vm.activeValueMonthly ===
                                  _vm.customValue.monthlyAmount,
                                "french-donation": _vm.isFrenchLanguage,
                              },
                              on: {
                                click: function ($event) {
                                  _vm.activeValueMonthly =
                                    _vm.customValue.monthlyAmount
                                  _vm.errors = []
                                },
                              },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "field__label",
                                  attrs: {
                                    "aria-label": _vm.otheramounttext,
                                    for: _vm.customValue.idMonthly,
                                  },
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.otheramounttext)),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.isFrenchLanguage
                                ? _c(
                                    "div",
                                    { staticClass: "field__currency" },
                                    [_c("div", [_vm._v("$/mois")])]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "field__currency" },
                                    [
                                      _c("div", [_vm._v("$")]),
                                      _vm._v(" "),
                                      _c("div", [_vm._v("/mo")]),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.customValue.monthlyAmount,
                                    expression: "customValue.monthlyAmount",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "field__input",
                                attrs: {
                                  id: _vm.customValue.idMonthly,
                                  autocomplete: "off",
                                  inputmode: "decimal",
                                  maxlength: "8",
                                  pattern: "\\d+(\\.\\d*)?",
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.customValue.monthlyAmount,
                                },
                                on: {
                                  keyup: function ($event) {
                                    _vm.activeValueMonthly =
                                      _vm.customValue.monthlyAmount
                                  },
                                  keypress: _vm.preventNonNumeric,
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.customValue,
                                      "monthlyAmount",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ],
                  2
                ),
          ]
        ),
        _vm._v(" "),
        _vm.errors.length
          ? _c(
              "div",
              { staticClass: "donation-starter__error" },
              _vm._l(_vm.errors, function (error, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "field__error theme theme--light-grey",
                  },
                  [_vm._v("\n        " + _vm._s(error) + "\n      ")]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "donation-starter__submit" }, [
          _c(
            "div",
            {
              staticClass: "btn btn--blue",
              attrs: {
                "aria-label": _vm.submitButtonCta,
                role: "button",
                tabindex: "0",
              },
              on: {
                click: function ($event) {
                  return _vm.goToDonationForm()
                },
              },
            },
            [
              _c("span", { staticClass: "btn__content" }, [
                _c("span", { staticClass: "btn__text" }, [
                  _vm._v(_vm._s(_vm.submitButtonCta)),
                ]),
              ]),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field__currency" }, [
      _c("div", [_vm._v("$")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }